module.exports = __webpack_public_path__ + "static/media/pay-paypal-off.0c17616e.png";